import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import "@tKgpco/Store/Reducer";
import "@tKgpco/theme";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import { css } from "styled-components";

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
// const pages = require.context("./Pages", true, /\.tsx$/);
// const onHotPageReplace = addPagesFromContext(pages);
// if (module.hot) {
//     module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
const handlers = require.context("./Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./Extensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

setPostStyleGuideTheme({
    globalStyle: {
        css: css`
            button {
                &:disabled:hover {
                    background: ${COLORS.disabled.base} !important;
                }
            }

            @media print {
                html {
                    [class^="PageLayoutWrapper"] {
                        > span[class^="TypographyStyle"] {
                            display: none;
                        }
                    }
                }

                @page {
                    size: auto;
                    margin: 0mm;
                }
                .hide-for-print,
                header {
                    display: none !important;
                }

                #print-div {
                    display: block !important;
                    margin: 3em;
                }
            }
        `,
    },
    formField: {
        defaultProps: {
            cssOverrides: {
                formField: css`
                    > div {
                        margin-top: 5px !important;
                    }
                    input {
                        border-radius: 4px !important;
                        overflow-wrap: break-word !important;
                        word-break: break-all !important;
                        font-size: 14px !important;
                    }
                    textarea {
                        border-radius: 4px !important;
                        overflow-wrap: break-word !important;
                        font-size: 14px !important;
                        word-break: break-all !important;
                    }
                    select {
                        border-radius: 4px !important;
                        font-size: 14px !important;
                        padding: 0 38px 0 10px !important;
                    }
                `,
            },
        },
    },
    pagination: {
        defaultProps: {
            cssOverrides: {
                perPageSelect: css`
                    label {
                        /*border: 1px solid red;*/
                        padding: 10px 10px 0 0;
                        select[data-test-selector^="paginationPerPageSelect"] {
                            height: 26px !important;
                        }
                        span {
                            height: 24px !important;
                            right: 0px !important;
                        }
                    }
                `,
                linkList: css`
                    button {
                        /*border: 1px solid #3c75b5;*/
                        border-radius: 50px;
                        padding: 0 0 !important;
                        width: 35px;
                        height: 35px;
                        background: none;
                    }
                    button[aria-current^="page"] {
                        border: 1px solid #3c75b5;
                    }
                `,
                pagination: css`
                    padding: 5px 0;
                    background: #f1f6fb;
                    justify-content: center !important;
                `,
            },
        },
    },
    checkbox: {
        defaultProps: {
            css: css`
                span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                    background: #fff;
                    border: 1px solid #bebdbd;
                    color: #19a3e0;
                }
                span[role="checkbox"]:focus {
                    outline: none;
                    box-shadow: 0 0 0 1px #e2e3e6;
                }
            `,
        },
    },
    modal: {
        defaultProps: {
            sizeVariant: "small",
            size: 600,
            cssOverrides: {
                modalTitle: css`
                    padding: 10px 0;
                    margin: 10px 30px;
                    border-bottom: 1px solid #e2e7ec;
                    h4 {
                        font-size: ${TYPOGRAPHY.size.largest};
                        font-weight: ${TYPOGRAPHY.weight.bold};
                    }
                `,
                modalContent: css`
                    padding: 20px 30px;
                `,
            },
            closeButtonProps: {
                css: css`
                    opacity: 0.9;
                    padding: 0;
                    background: ${COLORS.white};
                    border: 2px solid ${COLORS.white} !important;
                    border-width: 0 !important;
                `,
            },
        },
    },
    datePicker: {
        defaultProps: {
            cssOverrides: {
                datePicker: css`
                    .react-datetime-picker {
                        border-radius: 4px !important;
                        > div > div[class="react-datetime-picker__inputGroup"] {
                            pointer-events: none !important;
                        }
                    }
                `,
            },
        },
    },
    tag: {
        defaultProps: {
            css: css`
                display: flex;
                align-items: center;
                button {
                    background: ${COLORS.primary.light};
                    background: transparent;
                    height: 24px;
                    min-width: auto;
                    width: auto;
                    & :hover {
                        background: transparent;
                    }
                }
            `,
        },
    },
    tooltip: {
        defaultProps: {
            cssOverrides: {
                tooltipContainer: css`
                    &::after {
                        border-color: #b3b3b3 transparent transparent transparent !important;
                    }
                `,
                tooltipBody: css`
                    font-weight: 400;
                    background: #b3b3b3;
                `,
            },
        },
    },
    overflowMenu: {
        defaultProps: {
            buttonProps: {
                css: css`
                    border: 1px solid ${COLORS.white};
                    background: ${COLORS.white};
                    & :focus {
                        outline-width: 0px;
                    }
                `,
            },
        },
    },
    dynamicDropdown: {
        defaultProps: {
            iconProps: {
                css: css`
                    position: absolute;
                    box-sizing: border-box;
                    top: 2px;
                    right: 2px;
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 100%;
                    pointer-events: none;
                `,
            },
        },
    },
    select: {
        defaultProps: {
            iconProps: {
                css: css`
                    position: absolute;
                    box-sizing: border-box;
                    top: 2px;
                    right: 2px;
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 100%;
                    pointer-events: none;
                `,
            },
        },
    },
    drawer: {
        defaultProps: {
            closeButtonIconProps: {
                css: css`
                    color: ${COLORS.white};
                `,
            },
            closeButtonProps: {
                css: css`
                    border: 0;
                    background: transparent;
                    color: ${COLORS.white};
                    & :focus {
                        outline-width: 0px;
                    }
                `,
            },
        },
    },
    textField: {
        defaultProps: {
            iconProps: {
                css: css`
                    position: absolute;
                    box-sizing: border-box;
                    top: 2px;
                    right: 2px;
                    width: 36px;
                    height: 36px;
                    padding: 8px;
                    border-radius: 100%;
                    pointer-events: none;
                `,
            },
        },
    },
    button: {
        primary: {
            typographyProps: {
                size: TYPOGRAPHY.size.smaller,
                weight: TYPOGRAPHY.weight.bold,
            },
            css: css`
                text-transform: uppercase;
                border-radius: 22px;
                background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
                border: none;
                color: ${COLORS.white};
                & :hover {
                    background: ${COLORS.secondaryBtn};
                }
                &:disabled {
                    background: ${COLORS.disabled.base};
                }
                &:disabled:hover {
                    background: ${COLORS.disabled.base};
                }
            `,
        },
        secondary: {
            typographyProps: {
                size: TYPOGRAPHY.size.smaller,
                weight: TYPOGRAPHY.weight.bold,
            },
            css: css`
                text-transform: uppercase;
                border-radius: 22px;
                border: 1px solid ${COLORS.secondaryBtn};
                background: ${COLORS.white};
                color: ${COLORS.secondaryBtn};
                & :hover {
                    background: ${COLORS.secondaryBg};
                    border: 1px solid ${COLORS.secondaryBtn};
                }
                &:disabled {
                    background: ${COLORS.disabled.base};
                    color: ${COLORS.white};
                }
                &:disabled:hover {
                    background: ${COLORS.disabled.base};
                    border: 1px solid ${COLORS.disabled.base};
                    color: ${COLORS.white};
                }
            `,
        },
    },
});
